/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-30 17:49:31
 * @FilePath: \frontend\src\utils\request.js
 */
import axios from 'axios';
import axiosRetry from 'axios-retry';
import router from '@/router';
import store from '@/store';
import { fetchAuthSession } from 'aws-amplify/auth';
import { amplifySignOut } from './auth';
import {
  // ElNotification,
  ElMessage,
} from 'element-plus';
import {
  //errorMsg,
  warningMsg,
} from './message';
// import { i18n } from '@/Lang/index';
import { PF_API_ENDPOINT, PF_API_STAGE } from '@/aws-exports';

export const baseURL = `${PF_API_ENDPOINT[import.meta.env.MODE]}/${PF_API_STAGE}`;

axios.defaults.headers.post['Content-Type'] = 'application/json';

// create an axios instance
const service = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 120, // request timeout
  // withCredentials: true, // send cookies when cross-domain requests
});

// WARNING: Check interceptor execution order, when update axios version
// request: Reverse
// response: Forward

// request interceptor: before axios-retry
// refresh expired token
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  async (error) => {
    /*
    const config = error.config;
    if (error.response.status === 401 && !config.__isRetryRequest) {
      config.__isRetryRequest = true;
      try {
        const session = await fetchAuthSession();
        const idToken = session.tokens.idToken;
        const token = idToken.toString();
        await store.dispatch('user/setToken', token);
        return service(config);
      } catch {
        if (router.path !== '/login') {
          await amplifySignOut();
          ElMessage({
            message: warningMsg.Login_timeout,
            type: 'warning',
            duration: 5 * 1000,
            customClass: 'notify',
          });
          router.push('/login');
        }
      }
    }
    */
    return Promise.reject(error);
  }
);

// axios-retry: automatically exponential backoff retry
// retryCondition: Network Error and 5xx Error (Default)
axiosRetry(service, {
  retryDelay: axiosRetry.exponentialDelay,
});

// request interceptor: before axios-retry
// refresh expired token
service.interceptors.request.use(
  async (config) => {
    if (store.getters.token) {
      const token = store.getters.token.token;
      const expire = store.getters.token.expire;
      if (new Date() < new Date(expire)) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        try {
          const session = await fetchAuthSession();
          const idToken = session.tokens.idToken;
          const token = idToken.toString();
          const expire = idToken.payload.exp * 1000;
          await store.dispatch('user/setToken', { token: token, expire: expire });
          config.headers.Authorization = `Bearer ${token}`;
        } catch {
          if (router.path !== '/login') {
            await amplifySignOut();
            ElMessage({
              message: warningMsg.Login_timeout,
              type: 'warning',
              duration: 5 * 1000,
              customClass: 'notify',
            });
            router.push('/login');
          }
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Executed multiple times after recursive retry execution
// response interceptor: after axios-retry
/*
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {    
    ElNotification({
      title: i18n.global.t('request.error'),
      message: errorMsg.e_req_timeout,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });
    return Promise.reject(error);
  }
);
*/

export default service;
